// assets\quickview.js.liquid
$(document).ready(function () { 
  var quickview = $('.quickview');

  var main_image=$('#productModal .modal-body .product-images .main-image img'),

      main_href=$('#productModal .modal-body .product-images .main-image a'),

      quickview_labels=$('#productModal .modal-body .product-images .main-image .images-container .quickview-labels'),

      other_image=$('#productModal .modal-body .product-images .other-image  ul'),

      rating=$('#productModal .modal-body .product-desc .rating'),

      modal_title=$('#productModal .modal-body .product-info h1'),

      price=$('#productModal .modal-body .product-info .price-box .price .special-price'),

      price_from=$('#productModal .modal-body .product-info .price-box .from-label'),

      modal_desc=$('#productModal .modal-body .product-info .quick-desc'),

      main_desc_href=$('#productModal .modal-body .product-info .see-all'),

      share=$('#productModal .modal-body .product-info .social-sharing'),

      btn_wishlist=$('#productModal .modal-body .product-info .action-links .wishlist-btn'),

      btn_config_options=$('#productModal .modal-body .product-info .action-links .configure-options-btn-selector');

  field_add=$('#productModal .modal-body .product-info .quick-add-to-cart #id');

  btn_compare=$('#productModal .modal-body .product-info .button-group .btn-compare');	

  function readProductInfo(el) {
    var raw = el.getAttribute('data-productinfo');
    if (!raw) return null;
    raw = raw.replace(/^\uFEFF/, '').trim();
    try {
      return JSON.parse(raw);
    } catch (err) {
      return null;
    }
  }

  function imageSrc(item) {
    if (!item) return '';
    if (typeof item === 'string') return item;
    if (item.src) return item.src;
    return '';
  }

  function setModalMainImage(src) {
    var img = main_image[0];
    if (!img) return;
    src = imageSrc(src);

    img.classList.remove('is-shown');
    if (src) img.src = src;
    else img.removeAttribute('src');

    if (window.ImageSkeleton) {
      ImageSkeleton.reinit('#productModal');
    }
  }

  $('body').on('click', '.quickview', function (e){
    other_image.empty();

    rating.empty();

    price.empty();

    price_from.empty();

    quickview_labels.empty();

    var product_info = readProductInfo(this);
    if (!product_info) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    var arr_image = product_info['images'] || [];
    setModalMainImage(imageSrc(arr_image[0]));

    main_href.attr('href','/products/'+product_info['handle']);

    for(var i=0;i<arr_image.length&&i<3;i++){ 			

      other_image.append('<li><img style="width:78px;cursor:pointer" class="img-thumbnail other-image" src="'+arr_image[i]+'"></li>')
    }

    $('.other-image').off('click.qvthumb').on('click.qvthumb', function(){
      setModalMainImage($(this).attr('src'));
    });

    modal_title.html(product_info['title'] || '');

    var desc = (product_info['description'] || '').toString();
    var res = desc.trim();
    modal_desc.html(res.substring(0, 150));
    rating.append('<span class="shopify-product-reviews-badge" data-id="'+ product_info["id"] +'"></span>');

    var priceToShow = product_info['price_varies'] ? product_info['price_min'] : product_info['price'];

    if(product_info['price']){
      if(product_info['price_varies']){
        price_from.html('From');
      }

      if(product_info['compare_at_price'] && product_info['compare_at_price'] > priceToShow ){ 
        if (typeof Currency !== 'undefined') {
          price.append('<span class="new-price"><span class="price">'+ Currency.moneyFormats[shopCurrency].money_format.substring(0,1) + (priceToShow/100).toFixed(2) +'</span></span><span class="old-price"><span class="price">'+ Currency.moneyFormats[shopCurrency].money_format.substring(0,1) + (product_info["compare_at_price"]/100).toFixed(2) +'</span></span>');
        } else {
          price.append('<span class="new-price"><span class="price">' + moneyFormat.replace("\{\{amount\}\}", "") + (priceToShow/100).toFixed(2) +'</span></span><span class="old-price"><span class="price">'+ moneyFormat.replace("\{\{amount\}\}", "") + (product_info["compare_at_price"]/100).toFixed(2) +'</span></span>');
        }
      }else{ 			
        if (typeof Currency !== 'undefined') {
          price.append('<span class="new-price"><span class="price">'+ Currency.moneyFormats[shopCurrency].money_format.substring(0,1) + (priceToShow/100).toFixed(2) +'</span></span>');
        } else {
          price.append('<span class="new-price"><span class="price">'+ moneyFormat.replace("\{\{amount\}\}", "") + (priceToShow/100).toFixed(2) +'</span></span>');
        }
      }
    }
    

    // --- Labels: sold out / new / on sale ---
    // sold_out takes priority: if sold out, show only "Sold out" and suppress new/sale.
    var isSoldOut = !product_info['available'];
    var isOnSale = !!(product_info['compare_at_price'] && product_info['compare_at_price'] > priceToShow);

    if (isSoldOut) {
      quickview_labels.append(
        '<div class="label-product label-product-large label-left-large"><span>Sold Out</span></div>'
      );
    } else {
      var productNewTimeDays = 30;
      if (product_info['created_at']) {
        var createdAtMs = new Date(product_info['created_at']).getTime();
        var daysAgo = (Date.now() - createdAtMs) / 86400000;
        if (daysAgo < productNewTimeDays) {
          quickview_labels.append(
            '<div class="label-product label-product-large label-right-large"><span>New</span></div>'
          );
        }
      }

      if (isOnSale) {
        var percentOff = Math.round((product_info['compare_at_price'] - priceToShow) * 100.0 / product_info['compare_at_price']);
        quickview_labels.append(
          '<div class="label-product label-product-large label-left-large"><span>-' + percentOff + '%</span></div>'
        );
      }
    }
    // --- end labels ---

    btn_wishlist.attr('data-product-handle', product_info['handle']);
    if (window.Wishlist && typeof Wishlist.refresh === 'function') {
      Wishlist.refresh();
    }

    btn_config_options.attr('onclick', "location.href='/products/" + product_info['handle'] + "';");

  });
});
